<template>
    <div id="admin-menu">
        <div class="hover-leftline pt-4 px-3">
            <img class="topbar-logo" src="../../src/assets/images/spade-logo.png" />
            <br>
        </div>
        <hr>
        <ul id="menu-list" class="nav flex-column mt-2">
            <li class="nav-item" v-if="hasAnyRole('Supervisor', 'Administrator')">
                <router-link class="menu-link" to="/admin/user">User</router-link>
            </li>
            <li class="nav-item" v-if="hasAnyRole('Supervisor', 'Administrator')">
                <router-link class="menu-link" to="/admin/tenant">Tenant</router-link>
            </li>
            <li class="nav-item" v-if="hasAnyRole('Supervisor', 'Administrator')">
                <router-link class="menu-link" to="/admin/device">Peon</router-link>
            </li>
            <li class="nav-item" v-if="hasAnyRole('Supervisor', 'Administrator')">
                <router-link class="menu-link" to="/admin/group">Group</router-link>
            </li>
            <li class="nav-item" v-if="hasAnyRole('Supervisor', 'Administrator')">
                <router-link class="menu-link" to="/admin/config">Config</router-link>
            </li>
            <li class="nav-item" v-if="hasAnyRole('Supervisor', 'Administrator')">
                <router-link class="menu-link" to="/admin/license">License</router-link>
            </li>
            <li class="nav-item" v-if="hasAnyRole('Supervisor', 'Administrator')">
                <router-link class="menu-link" to="/admin/kakao">Kakao</router-link>
            </li>
            <li class="nav-item" v-if="hasAnyRole('Supervisor', 'Administrator')">
                <router-link class="menu-link" to="/admin/kakaoAuthority">Kakao Authority</router-link>
            </li>
            <li class="nav-item" v-if="hasAnyRole('Supervisor', 'Administrator')">
                <router-link class="menu-link" to="/admin/kakaoGroup">Kakao Group</router-link>
            </li>
        </ul>
    </div>
</template>
    
<script>
export default {
    name: 'SideBar'
}
</script>
    